import { ApiService } from '@b2b/common/services/api/types';
import { TODO } from '@b2b/types/core';
import angular, { IScope } from 'angular';

export const CustomFieldsEditDirectiveModule = angular
  .module('acme.common.directive.customFieldsEdit', [])
  .directive('customFieldsEdit', [
    function CustomFieldsEditDirective() {
      return {
        restrict: 'A',
        replace: true,
        templateUrl: 'common/directives/customFields/edit/edit.tpl.html',
        scope: {
          max: '=',
          editFields: '=',
        },

        link: function ($scope, $element, $attrs) {
          // Modified after controller runs
        },

        controller: [
          '$scope',
          'ApiService',
          'HelpersService',
          function CustomFieldsEditController(
            $scope: IScope & { customFieldsEdit: TODO; editFields: TODO[]; max: TODO },
            ApiService: ApiService,
            HelpersService: TODO
          ) {
            $scope.customFieldsEdit = {
              fields: [],

              init: function () {
                $scope.$on(
                  '$destroy',
                  $scope.$watchCollection('editFields', function (n, o) {
                    $scope.customFieldsEdit.process($scope.customFieldsEdit.fields);
                  })
                );
                ApiService.customFields.list(HelpersService.getPaginator()).then(this.success.init, this.error.init);
              },

              remove: function (index) {
                $scope.editFields.splice(index, 1);
              },

              isMax: function () {
                return $scope.editFields.length >= $scope.max;
              },

              hasFields: function () {
                return $scope.editFields instanceof Array && $scope.editFields.length > 0;
              },

              process: function (fields) {
                var i, ii, j, jj, found;

                for (i = 0, ii = fields.length; i < ii; i++) {
                  found = false;
                  for (j = 0, jj = $scope.editFields.length; j < jj; j++) {
                    if (fields[i].label === $scope.editFields[j].name && fields[i].format === 'Dropdown') {
                      $scope.editFields[j].values = fields[i].values;
                      $scope.editFields[j].format = fields[i].format;
                      found = true;
                      break;
                    } else if (fields[i].label === $scope.editFields[j].name) {
                      if (!!fields[i].format) {
                        $scope.editFields[j].format = fields[i].format;
                      }
                      found = true;
                      break;
                    }
                  }
                  if (!found) {
                    $scope.editFields.push({
                      format: fields[i].format,
                      name: fields[i].label,
                      values: fields[i].values,
                      value: '',
                    });
                  }
                }
              },

              success: {
                init: function (response) {
                  var self = $scope.customFieldsEdit;
                  self.fields = response.data.payload.list;
                  self.process(response.data.payload.list);
                },
              },

              error: {
                init: function () {},
              },
            };

            $scope.customFieldsEdit.init();
          },
        ],
      };
    },
  ]).name;
